import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import PrimaryButtonV2 from './PrimaryButtonV2';
import SpaceBetween from './SpaceBetween';
import { Button, Card } from 'antd';
import { AlertActions } from 'redux/actions';

export default function FileUploader(props) {
  const fileInputRef = useRef(null);
  const [files, setFiles] = useState([]);

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const newFiles = [];

    for (let file of selectedFiles) {
      const fileTypeAllowed = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'image/jpeg',
        'image/png',
      ];

      const isTooLarge = file.size > 1024 * 1024;
      const isInvalidType = !fileTypeAllowed.includes(file.type);

      if (isTooLarge) {
        AlertActions.error(`❌ ${file.name} ist größer als 1MB.`)
        continue;
      }

      if (isInvalidType) {
        AlertActions.error(`❌ ${file.name} hat einen nicht unterstützten Dateityp.`);
        continue;
      }

      newFiles.push(file);
    }

    const totlFiles = [...files, ...newFiles];
    if (totlFiles.length > 5) {
      AlertActions.error('Du kannst nur bis zu 5 Dateien hochladen.');
      return;
    }
    setFiles(totlFiles);
  };

  const handleRemoveFile = (indexToRemove) => {
    setFiles((prevFiles) =>
      prevFiles.filter((_, idx) => idx !== indexToRemove)
    );
  };

  const handleUpload = async () => {
    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append('files[]', files[i]);
    }

    if (props.closeModal) props.closeModal();

    props.uploadFiles(props.projectId, formData);
  };

  const handleFileButtonClick = () => {
    fileInputRef.current.click();
  };

  return (
    <div>
      <input
        type="file"
        multiple
        accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
        style={{ display: 'none' }}
        ref={fileInputRef}
        onChange={handleFileChange}
      />
      <SpaceBetween style={{ marginTop: 24 }}>
        <PrimaryButtonV2 primary={true} onClick={handleFileButtonClick}>
          Dateien auswählen
        </PrimaryButtonV2>

        <PrimaryButtonV2 disabled={files.length <= 0} onClick={handleUpload}>
       Hochladen
        </PrimaryButtonV2>
      </SpaceBetween>

      {files.length > 0 && (
        <Card style={{ marginTop: 24, background: '#fafafa' }}>
          <div style={{ marginTop: 16 }}>
            <h4>Hochzuladende Dateien</h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {files.map((file, idx) => (
                <li
                  key={file.filename}
                  style={{
                    marginBottom: 10,
                    padding: '10px',
                    border: '1px solid #e5e5e5',
                    borderRadius: 4,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div>
                    <strong>{file.name}</strong>
                    <div style={{ fontSize: '0.85em', color: '#888' }}>
                      {(file.size / 1024).toFixed(1)} KB
                    </div>
                  </div>
                  <Button
                    type="primary"
                    ghost
                    size="small"
                    onClick={() => handleRemoveFile(idx)}
                  >
                    Entfernen
                  </Button>
                </li>
              ))}
            </ul>
          </div>
        </Card>
      )}

      {/*files.length > 0 && (
        <div style={{ marginTop: 12 }}>
          <ul style={{ paddingLeft: 16 }}>
            {files.map((file, idx) => (
              <li key={idx}>
                {file.name} – {(file.size / 1024).toFixed(1)} KB
              </li>
            ))}
          </ul>
        </div>
      )*/}
    </div>
  );
}

FileUploader.propTypes = {
  projectId: PropTypes.number.isRequired,
  uploadFiles: PropTypes.func.isRequired,
  closeModal: PropTypes.func,
};
